package components.form

import it.neckar.commons.kotlin.js.getNotNull
import it.neckar.commons.kotlin.js.safeGet
import it.neckar.lizergy.model.energy.BatteryCapacity
import it.neckar.lizergy.model.energy.PowerRating
import it.neckar.react.common.*
import it.neckar.react.common.form.*
import plannerI18nConfiguration
import react.*
import react.dom.*

/**
 * Form for a label and a longer description
 */
fun RBuilder.configurationDescriptionForm(
  label: StateInstance<String>,
  description: StateInstance<String>,
  labelPlaceholder: String,
  powerRating: PowerRating,
  storageCapacity: BatteryCapacity?,
  editableStatus: EditableStatus,
): Unit = child(ConfigurationDescriptionForm) {
  attrs {
    this.label = label
    this.description = description
    this.labelPlaceholder = labelPlaceholder
    this.powerRating = powerRating
    this.storageCapacity = storageCapacity
    this.editableStatus = editableStatus
  }
}

val ConfigurationDescriptionForm: FC<ConfigurationDescriptionFormProps> = fc("ConfigurationDescriptionForm") { props ->
  val label = props::label.getNotNull()
  val description = props::description.getNotNull()
  val labelPlaceholder = props::labelPlaceholder.safeGet()
  val powerRating = props::powerRating.safeGet()
  val storageCapacity = props::storageCapacity.safeGet()
  val editableStatus = props::editableStatus.safeGet()


  div {
    div("form-floating") {
      div("input-group") {
        floatingInputField(
          valueAndSetter = label,
          fieldName = "label",
          title = labelPlaceholder,
          editableStatus = editableStatus,
        ) {
          attrs {
            mergedBelow()
          }
        }
        span("input-group-text") {
          +powerRating.formatKiloWattPeak(plannerI18nConfiguration)
        }
        storageCapacity?.let {
          span("input-group-text") {
            +storageCapacity.format(plannerI18nConfiguration)
          }
        }
      }
    }

    div("form-floating") {
      floatingInputArea(
        valueAndSetter = description,
        fieldName = "description",
        title = "Beschreibung",
        editableStatus = editableStatus,
      ) {
        attrs {
          mergedAbove()
        }
      }
    }
  }
}

external interface ConfigurationDescriptionFormProps : Props {
  var label: StateInstance<String>
  var description: StateInstance<String>
  var labelPlaceholder: String
  var powerRating: PowerRating
  var storageCapacity: BatteryCapacity?
  var editableStatus: EditableStatus
}
